class DataCollector {
  constructor(root, onChange) {
    this.root = root;
    this.onChange = onChange;
    this.data = {};
    this.defaultData = {};

    this.bindInitialFields();
  }

  bindInitialFields() {
    const inputs = this.root.querySelectorAll('[data-id]');
    inputs.forEach(input => {
      const path = this.buildPath(input);
      if (!path) return;

      const pathStr = path.join('.');
      if (this.pathExists(path)) {
        console.warn(`[DataCollector] Duplicate path: ${pathStr}`);
      }

      const value = this.readValue(input);
      this.updateValueAtPath(path, value);
      this.updateDefaultValueAtPath(path, value);
      this.bindInput(input, path);
    });
  }

  bindNewFields(container) {
    const inputs = container.querySelectorAll('[data-id]');
    inputs.forEach(input => {
      const path = this.buildPath(input);
      if (!path) return;

      const value = this.readValue(input);
      this.updateValueAtPath(path, value);
      this.updateDefaultValueAtPath(path, value);

      if (input.__bound) return;
      input.__bound = true;

      this.bindInput(input, path);
    });
  }

  bindInput(input, path) {
    const eventType = ['checkbox', 'radio'].includes(input.type) ? 'change' : 'input';
    input.addEventListener(eventType, event => {
      const value = this.readValue(input);
      if (value === undefined) return;
      this.updateValueAtPath(path, value);
      let inputName = event.target.getAttribute("name");
      if (event.target.matches("input[type='radio']")) {
        let linkedInputs = document.querySelectorAll(`input[type='radio'][name='${inputName}']`);
        linkedInputs.forEach(input => {
          if (input == event.target) return;
          const value = this.readValue(input);
          if (value === undefined) return;
          const path = this.buildPath(input);
          if (!path) return;
          this.updateValueAtPath(path, value);
        });
      }
      this.onChange?.(path.join('.'), value);
    });
  }

  updateDefaultValueAtPath(path, value) {
    let ref = this.defaultData;
    path.forEach((key, i) => {
      if (i === path.length - 1) {
        if (!(key in ref)) ref[key] = value;
      } else {
        if (typeof ref[key] !== 'object' || ref[key] === null) {
          ref[key] = {};
        }
        ref = ref[key];
      }
    });
  }

  pathExists(path) {
    let ref = this.data;
    for (let i = 0; i < path.length - 1; i++) {
      if (typeof ref[path[i]] !== 'object' || ref[path[i]] === null) return false;
      ref = ref[path[i]];
    }
    return path[path.length - 1] in ref;
  }

  buildPath(input) {
    const parts = [];
    let el = input;
    while (el && el !== this.root) {
      if (el.hasAttribute('data-id')) {
        parts.unshift(el.getAttribute('data-id'));
      }
      el = el.parentElement;
    }
    return parts.length ? parts : null;
  }

  readValue(input) {
    if (input.type === 'checkbox') return input.checked;
    if (input.type === 'radio') return input.checked ? true : false;
    return input.value;
  }

  updateValueAtPath(path, value) {
    let ref = this.data;
    path.forEach((key, i) => {
      if (i === path.length - 1) {
        ref[key] = value;
      } else {
        if (typeof ref[key] !== 'object' || ref[key] === null) {
          ref[key] = {};
        }
        ref = ref[key];
      }
    });
  }

  getData() {
    return this.data;
  }
  getDefaultData() {
    return this.defaultData;
  }

  getInputByPath(path) {
    const selector = path.map(id => `[data-id="${id}"]`).join(' ');
    return this.root.querySelector(selector);
  }
}

export default DataCollector;
